import request from "@/utils/request";
import SERVICE from "./enums";

// 获取数据源列表
export function getDataSource(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/datasource`,
    method: "get",
    data,
  });
}
export function getDataAccount(params, data = {}) {
  return request({
    url: `${SERVICE.API_MEDIA}/adAccounts`,
    method: "post",
    params,
    data,
  });
}
// 依据数据权限，获取对应的列表
export function getDataDimension(params, data = {}) {
  return request({
    url: `${SERVICE.API_MEDIA}/userAssetAuth/getUserAssets`,
    method: "post",
    params,
    data,
  });
}
export function getDimensionList(params, data = {}) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/dimensions`,
    method: "post",
    params,
    data,
  });
}
export function getFieldsByCode(params, data = {}) {
  return request({
    url: `${SERVICE.API_MEDIA}/datasource/findFieldsByCode`,
    method: "post",
    params,
    data,
  });
}
export function getNormList(params, data = {}) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/metrics`,
    method: "post",
    params,
    data,
  });
}
export function getApplyData(params, data = {}) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/widgetAnalysis/preview`,
    method: "post",
    params,
    data,
  });
}

// 维度和指标筛选
export function getFields(params, data = {}) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/search`,
    method: "post",
    params,
    data,
  });
}

// 上传
export function uploadFile(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/file/upload`,
    method: "post",
    data
  });
}

// 获取智能预警数据源列表
export function getWarnDataSource(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/datasource/intelligentWarnDataSource`,
    method: "get",
    data,
  });
}

// // 注册
// export function register(data) {
//   return request({
//     url: `${SERVICE.API_AUTH}/sysAuth/register`,
//     method: "post",
//     data,
//   });
// }

// 获取数据集列表
export function getTables(datasourceId) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTable/tables/${datasourceId}`,
    method: "get",
  });
}
